import ApisServiceApp from '@api/ApisServiceApp'
import { IProduct, IProductImportInfo } from '@interfaces/productInterfaces'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

export function createProduct(data: IProduct) {
  try {
    return ApisServiceApp.post('/product/create-product', data)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function updateProduct(data: IProduct) {
  try {
    return ApisServiceApp.put('/product/' + data.id + '/update-product', data)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}


export function getDetailProduct(id: string) {
  try {
    return ApisServiceApp.get('/product/' + id + '/get-chitiet-product')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}


export function getListProduct(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/product/filter-product', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}


export function getListOptionProduct(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/product/filter-product', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function deleteProduct(id: string) {
  try {
    return ApisServiceApp.delete('/product/' + id + '/delete-product')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function deleteMultiProduct(idArr: Array<string>) {
  try {
    return ApisServiceApp.delete('/product/bulk-delete-product', { data: idArr })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}


export function importProductInfo(data: Array<IProductImportInfo>) {
  try {
    return ApisServiceApp.post('/product/import-thongtinthemsanpham', data, {
      timeout: 300000, // 5 phút (300 giây) cho request import dài
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}